import { Navigate, Route, Routes, useLocation } from 'react-router'
import HospitalizationSummaryPage from './components/HospitalizationSummaryPage'
import '../../components/summary/Summary.scss'
import './HospitalizationSummary.scss'

/**
 * Indicadores de internación (reemplaza a `summaryhospitalizationsview` de Vaadin).
 *
 * Una sola pantalla con pestañas: la lista, los internados hoy y las evoluciones médicas ya no son páginas aparte. Se
 * registra con `/*` en `routeComponents` para que quede adentro del Dashboard, con su menú y encabezado; cualquier subruta
 * vieja (`…/detail`, `…/evolutions`) vuelve al resumen.
 */
export default function HospitalizationSummaryView() {
  const { pathname } = useLocation()
  // Ruta del resumen, estemos en el resumen o en una subruta vieja
  const basePath = pathname.replace(/(summaryhospitalizationsview).*$/, '$1')

  return (
    <Routes>
      <Route index element={<HospitalizationSummaryPage />} />
      <Route path="*" element={<Navigate to={basePath} replace />} />
    </Routes>
  )
}
